<template>
  <a-modal
    v-drag-modal
    centered
    :visible.sync="visible"
    :mask-closable="false"
    width="600px"
    okText="确定"
    cancelText="取消"
    @ok="selectOk"
    @cancel="visible = false">
    <div slot="title">
      <label>{{ title }}</label>
      <a-radio-group v-if="isSwitchingRole" v-model="selectedType" @change="changeType" style="margin-left: 10px">
        <a-radio-button value="org">人员/部门</a-radio-button>
        <a-radio-button value="role">角色</a-radio-button>
      </a-radio-group>
    </div>
    <div class="picker">
      <div class="candidate">
        <div>
          <a-input
            v-if="localType === 'role' && !currentNodeIds"
            v-model="roleName"
            @input="searchRole"
            style="width: 95%"
            allow-clear
            placeholder="搜索角色">
            <a-icon slot="prefix" type="search" />
          </a-input>
          <a-input
            v-else
            v-model="search"
            @input="searchUser"
            style="width: 95%"
            allow-clear
            placeholder="搜索人员，支持拼音、姓名">
            <a-icon slot="prefix" type="search" />
          </a-input>
          <div v-show="!showUsers">
            <ellipsis hoverTip style="height: 24px; color: #8c8c8c; padding: 5px 0 0" :row="1" :content="deptStackStr">
              <i slot="pre" class="el-icon-office-building"></i>
            </ellipsis>
            <div style="margin-top: 5px">
              <a-checkbox v-model="checkAll" @change="handleCheckAllChange" :disabled="!multiple">全选</a-checkbox>
              <span v-show="deptStack.length > 0" class="top-dept" @click="beforeNode">上一级</span>
            </div>
          </div>
        </div>
        <a-spin :spinning="loading">
          <div class="org-items">
            <a-empty :image-size="100" description="似乎没有数据" v-show="orgs.length === 0" />
            <div v-for="(org, index) in orgs" :key="org.type_id" :class="orgItemClass(org)" @click="selectChange(org)">
              <a-checkbox v-model="org.selected" :disabled="disableDept(org)"></a-checkbox>
              <div v-if="['role', 'dept'].includes(org.type)">
                <i
                  :class="org.type === 'dept'
                    ? 'el-icon-folder-opened'
                    : 'iconfont icon-bumen'
                  "></i>
                <span class="name">{{ org.name }}</span>
                <span @click.stop="nextNode(org)" :class="`next-dept${org.selected ? '-disable' : ''}`">
                  <i class="iconfont icon-map-site"></i>下级
                </span>
              </div>
              <div v-if="org.type === 'user'" style="display: flex; align-items: center">
                <a-avatar :size="35" :src="org.avatar" v-if="$isNotEmpty(org.avatar)" />
                <span v-else class="avatar">{{ getShortName(org.name) }}</span>
                <span class="name">{{ org.name }}</span>
              </div>
            </div>
          </div>
        </a-spin>
      </div>
      <div class="selected">
        <div class="count">
          <span>已选 {{ select.length }} 项</span>
          <span @click="clearSelected">清空</span>
        </div>
        <div class="org-items" style="height: 350px">
          <a-empty :image-size="100" description="请点击左侧列表选择数据" v-show="select.length === 0" />
          <div v-for="(org, index) in select" :key="org.type_id" :class="orgItemClass(org)">
            <div v-if="org.type === 'dept'">
              <i class="el-icon-folder-opened"></i>
              <span style="position: static" class="name">{{ org.name }}</span>
            </div>
            <div v-else-if="org.type === 'user'" style="display: flex; align-items: center">
              <a-avatar :size="35" :src="org.avatar" v-if="$isNotEmpty(org.avatar)" />
              <span v-else class="avatar">{{ getShortName(org.name) }}</span>
              <span class="name">{{ org.name }}</span>
            </div>
            <div v-else>
              <i class="iconfont icon-bumen"></i>
              <span class="name">{{ org.name }}</span>
            </div>
            <a-icon type="close" @click="noSelected(index)"></a-icon>
          </div>
        </div>
      </div>
    </div>
  </a-modal>
</template>

<script>
// import { postAction } from '@/api/manage'

export default {
  name: 'OrgPicker',
  components: {},
  props: {
    isSwitchingRole: {
      type: Boolean,
      default: false
    },
    title: {
      default: '请选择',
      type: String
    },
    type: {
      default: 'org',
      type: String
    },
    multiple: {
      default: false,
      type: Boolean
    },
    selected: {
      default: () => {
        return []
      },
      type: Array
    }
  },
  data() {
    return {
      visible: false,
      loading: false,
      checkAll: false,
      currentNodeIds: 0,
      isIndeterminate: false,
      searchUsers: [],
      nodes: [],
      select: [],
      search: '',
      deptStack: [
        {
          id: 0,
          name: '浙江瑞银电子有限公司'
        }
      ],
      roleName: '',
      selectedType: this.type,
      localType: this.type // 本地存储 type 的值
    }
  },
  computed: {
    deptStackStr() {
      return (
        '浙江瑞银电子有限公司 >' +
        this.deptStack.map((v) => v.name).join().replaceAll(',', ' > ')
      )
    },
    orgs() {
      return !this.search || this.search.trim() === ''
        ? this.nodes
        : this.searchUsers
    },
    showUsers() {
      return this.search || this.search.trim() !== ''
    }
  },
  watch: {
    type(newVal) {
      this.localType = newVal // 更新本地属性
    },
    selectedType(newVal) {
      if (typeof newVal === 'string') {
        this.$emit('update:type', newVal)
        this.localType = newVal // 更新本地属性而不是直接修改 props
      } else {
        console.error('selectedType should be a string')
      }
    }
  },
  methods: {
    changeType(val) {
      if (this.selectedType === 'role') {
        this.getRoleList()
      } else {
        this.getOrgList()
      }
    },
    show(ids = '', candidateList = []) {
      this.visible = true
      this.search = ''
      this.currentNodeIds = 0
      this.init()
      if (candidateList && candidateList.length) {
        this.getSelectList(candidateList)
      } else {
        if (this.localType === 'role') {
          if (ids) {
            this.currentNodeIds = ids
            this.getRoleUserById()
          } else {
            this.getRoleList()
          }
        } else {
          this.getOrgList()
        }
      }
      this.orgs.forEach(org => {
        org.selected = this.select.some(selectedNode => selectedNode.type_id === org.type_id)
      })
      console.warn('----this.select', this.select)
    },
    orgItemClass(org) {
      return {
        'org-item': true,
        'org-dept-item': org.type === 'dept',
        'org-user-item': org.type === 'user',
        'org-role-item': org.type === 'role'
      }
    },
    disableDept(node) {
      if (this.type === 'user' && this.isSwitchingRole) {
        return node.type !== 'user' // 只能选择 user 类型
      }
      return Boolean(this.localType === 'user' && node.type === 'dept' || (this.localType === 'role' && node.type === 'user' && this.deptStack.length))
    },
    searchRole() {
      this.getRoleList()
    },
    getRoleList() {
      this.loading = true
      let params = {
        curPage: 1,
        pageSize: 100,
        roleName: this.roleName,
        status: 1
      }
      this.$HttpService.post('/role/page', params).then((res) => {
        this.loading = false
        let roles = res.data.rows.map((v) => {
          return {
            name: v.roleName,
            id: v.roleId,
            type: 'role',
            type_id: `role_${v.roleName}` // 组合 type 和 id 作为唯一标识
          }
        })

        this.nodes = [...roles]
        this.selectToLeft()
      })
    },
    // 针对自选审批人-候选人数据，需要特殊处理
    getSelectList(userList) {
      this.nodes = [...userList]
      this.selectToLeft()
    },
    getRoleUserById() {
      this.$HttpService.post('/user/listusers', { roleIds: this.currentNodeIds }).then(
        (rsp) => {
          let users =
            rsp.data.map((v) => {
              return {
                name: v.fullName,
                username: v.username,
                id: v.id,
                type: 'user',
                type_id: `user_${v.fullName}` // 组合 type 和 id 作为唯一标识
              }
            }) || []
          this.nodes = [...users]
          this.selectToLeft()
        }
      )
    },
    getOrgList() {
      this.loading = true
      this.$HttpService.post('/dept/list/all', {
        parentId: this.currentNodeIds || 0,
        type: this.localType
      })
        .then((rsp) => {
          this.loading = false
          let depts = rsp.data.map((v) => {
            return {
              name: v.deptName,
              id: v.id,
              type: 'dept',
              type_id: `dept_${v.deptName}` // 组合 type 和 id 作为唯一标识
            }
          })
          if (this.localType !== 'dept') {
            this.$HttpService.post('/user/listusers', { deptId: this.currentNodeIds }).then(
              (rsp) => {
                let users =
                  rsp.data.map((v) => {
                    return {
                      name: v.fullName,
                      username: v.username,
                      id: v.id,
                      type: 'user',
                      type_id: `user_${v.fullName}` // 组合 type 和 id 作为唯一标识
                    }
                  }) || []
                this.nodes = [...depts, ...users]
                this.selectToLeft()
              }
            )
          } else {
            this.nodes = [...depts]
          }
        })
        .catch((err) => {
          this.loading = false
          this.$message.error(err.response.data)
        })
    },
    getShortName(name) {
      if (name) {
        return name.length > 2 ? name.substring(1, 3) : name
      }
      return '**'
    },
    searchUser() {
      let userName = this.search.trim()

      this.searchUsers = []
      this.loading = true
      let params = {
        keyword: userName
      }
      if (this.currentNodeIds) {
        if (this.localType === 'role') {
          params.roleIds = this.currentNodeIds
        } else {
          params.deptId = this.currentNodeIds
        }
      }
      this.$HttpService.post('/user/listusers', params)
        .then((rsp) => {
          this.loading = false
          let users = rsp.data || []
          this.searchUsers = users.map((v) => {
            return {
              name: v.fullName,
              username: v.username,
              id: v.id,
              type: 'user',
              type_id: `user_${v.fullName}` // 组合 type 和 id 作为唯一标识
            }
          })
          this.selectToLeft()
        })
        .catch((err) => {
          this.loading = false
          this.$message.error('接口异常')
        })
    },
    selectToLeft() {
      let nodes = this.search.trim() === '' ? this.nodes : this.searchUsers
      nodes.forEach((node) => {
        if (!node.type_id) {
          node.type_id = `${node.type}_${node.name}`
        }
        for (let i = 0; i < this.select.length; i++) {
          if (this.select[i].type_id === node.type_id) {
            // 使用 type_id 进行比较
            node.selected = true
            break
          } else {
            node.selected = false
          }
        }
      })
    },
    selectChange(node) {
      if (node.selected) {
        this.checkAll = false
        for (let i = 0; i < this.select.length; i++) {
          if (this.select[i].type_id === node.type_id) {
            // 使用 type_id 进行比较
            this.select.splice(i, 1)
            break
          }
        }
        node.selected = false
      } else if (!this.disableDept(node)) {
        node.selected = true
        let nodes = this.search.trim() === '' ? this.nodes : this.searchUsers
        if (!this.multiple) {
          nodes.forEach((nd) => {
            if (node.type_id !== nd.type_id) {
              // 使用 type_id 进行比较
              nd.selected = false
            }
          })
        }
        if (node.type === 'dept') {
          if (!this.multiple) {
            this.select = [node]
          } else {
            this.select.unshift(node)
          }
        } else {
          if (!this.multiple) {
            this.select = [node]
          } else {
            this.select.push(node)
          }
        }
      }
    },
    noSelected(index) {
      let nodes = this.nodes
      for (let f = 0; f < 2; f++) {
        for (let i = 0; i < nodes.length; i++) {
          if (nodes[i].type_id === this.select[index].type_id) {
            // 使用 type_id 进行比较
            nodes[i].selected = false
            this.checkAll = false
            break
          }
        }
        nodes = this.searchUsers
      }
      this.select.splice(index, 1)
    },
    handleCheckAllChange() {
      this.nodes.forEach((node) => {
        if (this.checkAll) {
          if (!node.selected && !this.disableDept(node)) {
            node.selected = true
            this.select.push(node)
          }
        } else {
          node.selected = false
          for (let i = 0; i < this.select.length; i++) {
            if (this.select[i].type_id === node.type_id) {
              // 使用 type_id 进行比较
              this.select.splice(i, 1)
              break
            }
          }
        }
      })
    },
    nextNode(node) {
      this.currentNodeIds = node.id
      this.deptStack.push(node)
      if (this.localType === 'role') {
        this.getRoleUserById()
      } else {
        this.getOrgList()
      }
    },
    beforeNode() {
      if (this.deptStack.length === 0) {
        return
      }
      if (this.deptStack.length < 2) {
        this.currentNodeIds = 0
      } else {
        this.currentNodeIds = this.deptStack[this.deptStack.length - 2].id
      }
      this.deptStack.splice(this.deptStack.length - 1, 1)
      if (this.localType === 'role') {
        this.getRoleList()
      } else {
        this.getOrgList()
      }
    },
    recover() {
      this.select = []
      this.nodes.forEach((nd) => (nd.selected = false))
    },
    selectOk() {
      this.$emit(
        'ok',
        Object.assign(
          [],
          this.select.map((v) => {
            v.avatar = undefined
            return v
          })
        )
      )
      this.visible = false
      this.recover()
    },
    clearSelected() {
      this.$confirm({
        content: '您确定要清空已选中的项?',
        okText: '确定',
        cancelText: '取消',
        okType: 'primary',
        onOk: () => {
          this.recover()
        }
      })
    },
    close() {
      this.$emit('close')
      this.recover()
    },
    init() {
      this.checkAll = false
      this.currentNodeIds = 0
      this.deptStack = []
      this.nodes = []
      this.select = Object.assign([], this.selected)
      this.selectToLeft()
    }
  }
}
</script>

<style lang="less" scoped>
@containWidth: 278px;

.candidate,
.selected {
  position: absolute;
  display: inline-block;
  width: @containWidth;
  height: 400px;
  border: 1px solid #e8e8e8;
}

.picker {
  height: 402px;
  position: relative;
  text-align: left;

  .candidate {
    left: 0;
    top: 0;

    .top-dept {
      margin-left: 20px;
      cursor: pointer;
      color: #38adff;
    }

    .next-dept {
      position: absolute;
      right: 5px;
      color: #1890ff;
      cursor: pointer;
    }

    .next-dept-disable {
      position: absolute;
      right: 5px;
      color: #8c8c8c;
      cursor: not-allowed;
    }

    &>div:first-child {
      padding: 5px 10px;
    }
  }

  .selected {
    right: 0;
    top: 0;
  }

  .org-items {
    overflow-y: auto;
    height: 300px;

    .anticon-close {
      position: absolute;
      right: 5px;
      cursor: pointer;
      font-size: larger;
    }

    .org-dept-item {
      padding: 10px 5px;

      &>div {
        display: inline-block;

        &>span:last-child {
          position: absolute;
          right: 5px;
        }
      }
    }

    .org-role-item {
      display: flex;
      align-items: center;
      padding: 10px 5px;
    }

    ::v-deep .org-user-item {
      display: flex;
      align-items: center;
      padding: 5px;

      &>div {
        display: inline-block;
      }

      .avatar {
        width: 35px;
        text-align: center;
        line-height: 35px;
        background: #1890ff;
        color: white;
        border-radius: 50%;
      }
    }

    ::v-deep .org-item {
      margin: 0 8px;
      border-radius: 5px;
      position: relative;

      .ant-checkbox-wrapper {
        margin-right: 10px;
      }

      .name {
        margin-left: 5px;
      }

      &:hover {
        background: #f1f1f1;
      }
    }
  }
}

.selected {
  border-left: none;

  .count {
    width: @containWidth;
    padding: 10px;
    display: inline-block;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;

    &>span:nth-child(2) {
      float: right;
      color: #c75450;
      cursor: pointer;
    }
  }
}

::v-deep .ant-drawer-body {
  padding: 10px 20px;
}

.disabled {
  cursor: not-allowed !important;
  color: #8c8c8c !important;
}

::-webkit-scrollbar {
  float: right;
  width: 4px;
  height: 4px;
  background-color: white;
}

::-webkit-scrollbar-thumb {
  border-radius: 16px;
  background-color: #efefef;
}

@media (max-width: 768px) {

  .count,
  .candidate,
  .selected {
    width: 44vw !important;
  }

  .org-item {
    margin: 0 !important;
  }

  .org-dept-item {
    padding: 6px 5px !important;
  }

  .ant-checkbox-wrapper {
    margin-right: 4px !important;
  }

  /deep/ .ant-modal-body {
    padding: 10px !important;
  }

  .candidate {
    &>div:first-child {
      padding: 5px 5px !important;
    }
  }
}
</style>
